import { call, select } from 'redux-saga/effects';
import { toastr } from 'react-redux-toastr';
import { get } from 'lodash/fp';
import * as Api from '../../../../../services/fbm-api';
import { sagaRoutineRequest } from '../../../../../helpers/saga';
import {
  fetchSmtpAccounts as fetchSmtpAccountsRoutine,
  createSmtpAccount as createSmtpAccountRoute,
  updateSmtpAccount as updateSmtpAccountRoutine,
  deleteSmtpAccount as deleteSmtpAccountRoutine
} from './routines';
import { getSmtpAccounts } from '../../../selectors/portal/smtp-account';

export const fetchSmtpAccounts = ({ payload: { type } }) =>
  sagaRoutineRequest(fetchSmtpAccountsRoutine, {
    request: () => call(Api.fetchSmtpAccounts, { type })
  });

export const createSmtpAccount = ({ payload: body }) =>
  sagaRoutineRequest(createSmtpAccountRoute, {
    request: () => call(Api.createSmtpAccount, { body })
  });

export const updateSmtpAccount = ({ payload: { id, body } }) =>
  sagaRoutineRequest(updateSmtpAccountRoutine, {
    request: () => call(Api.updateSmtpAccount, { id, body }),
    *success() {
      const smtpAccounts = yield select(getSmtpAccounts);
      const smtpAccount = smtpAccounts[0];
      if (
        get('clientId', body) === get('clientId', smtpAccount) ||
        get('clientSecret', body) === get('clientSecret', smtpAccount)
      ) {
        yield toastr.success('Success', 'SMTP Account successfully updated.');
      }
    }
  });
export const deleteSmtpAccount = ({ payload: { id } }) =>
  sagaRoutineRequest(deleteSmtpAccountRoutine, {
    request: () => call(Api.deleteSmtpAccount, { id }),
    *success() {
      yield toastr.success('Success', 'SMTP Account successfully deleted.');
    }
  });
